import React from 'react';
import NumberFormat from 'react-number-format';

function FormatadorNumericoCustomizado(props) {
  const { inputRef, onChange, ...other } = props;

  return (
    <NumberFormat
      {...other}
      ref={inputRef}
      maxLength="12"
      allowNegative={false}
      onValueChange={values => {
        onChange({
          target: {
            value: values.value
          }
        });
      }}
    />
  );
}

export default FormatadorNumericoCustomizado;
